var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotdarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1827 5H3.81727C1.70905 5 0 6.70904 0 8.81726V41.1827C0 43.291 1.70905 45 3.81727 45H36.1827C38.291 45 40 43.291 40 41.1827V8.81726C40 6.70904 38.291 5 36.1827 5Z",
    fill: "#BC8C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4525 28.2637C22.0421 29.2387 21.4685 30.0767 20.7318 30.7812C19.9967 31.4856 19.1198 32.0366 18.1029 32.4374C17.0859 32.8383 15.9602 33.0379 14.7273 33.0379C13.4944 33.0379 12.4017 32.8366 11.3847 32.4374C10.3678 32.0366 9.49751 31.4839 8.77229 30.7812C8.04707 30.0767 7.48009 29.2387 7.06803 28.2637C6.65763 27.2888 6.4516 26.2281 6.4516 25.0799C6.4516 23.9317 6.65763 22.8759 7.06803 21.9125C7.48009 20.9491 8.04707 20.1094 8.77229 19.3951C9.49751 18.6808 10.3678 18.1282 11.3847 17.7388C12.4017 17.3495 13.5159 17.1548 14.7273 17.1548C15.9387 17.1548 17.0859 17.3495 18.1029 17.7388C19.1198 18.1282 19.9967 18.6808 20.7318 19.3951C21.4669 20.1094 22.0404 20.9491 22.4525 21.9125C22.8646 22.8759 23.0689 23.9317 23.0689 25.0799C23.0689 26.2281 22.8629 27.2888 22.4525 28.2637Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5871 32.4391C29.6041 32.0382 30.4809 31.4856 31.216 30.7828C31.9511 30.0784 32.5247 29.2404 32.9368 28.2654C33.3488 27.2904 33.5532 26.2297 33.5532 25.0815C33.5532 23.9334 33.3472 22.8776 32.9368 21.9142C32.5264 20.9507 31.9528 20.1111 31.216 19.3968C30.4809 18.6824 29.6041 18.1298 28.5871 17.7405C27.5801 17.3545 26.4642 17.1598 25.2445 17.1565V33.0396C26.4642 33.0363 27.5801 32.8366 28.5871 32.4391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotdarkTheme);
export default __webpack_public_path__ + "static/media/bot.darkTheme.854c6955023eecd4a9c768370c064b73.svg";
export { ForwardRef as ReactComponent };